export class TextUtils {
    static capitalizeText = (text: string) => {
        const excludeWords = ["y", "de", "la", "el", "en", "por", "a", "un"];
        return text
            .toLowerCase() // Convierte todo el texto a minúsculas
            .split(" ") // Divide el texto en palabras
            .map((word, index) => {
                // Capitaliza la primera palabra siempre, o si no está en la lista de exclusión
                if (index === 0 || !excludeWords.includes(word)) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                } else {
                    return word; // Devuelve la palabra sin cambios si está en la lista
                }
            })
            .join(" "); // Une las palabras de nuevo
    };
}
